import type { ReactNode } from "react";
import { useMemo } from "react";
import { View } from "@/components/ui";

type GridProps<T> = {
  data: T[];
  gap: number;
  columns: number;
  render: (item: T) => ReactNode;
};

export function Grid<T>({ data, gap, columns, render }: GridProps<T>) {
  const rows = useMemo((): (T | null)[][] => {
    const raw = Array.from(
      { length: Math.ceil(data.length / columns) },
      (_, rowIndex) =>
        data.slice(rowIndex * columns, rowIndex * columns + columns),
    );
    return raw.map((row): (T | null)[] => {
      const pad = columns - row.length;
      return pad > 0
        ? [...row, ...Array.from({ length: pad }, () => null)]
        : row;
    });
  }, [data, columns]);
  return (
    <View className="flex flex-col" style={{ gap }}>
      {rows.map((row, rowIndex) => (
        <View key={rowIndex} className="flex flex-row" style={{ gap }}>
          {row.map((cell, colIndex) => (
            <View key={colIndex} className="flex-1">
              {cell && render(cell)}
            </View>
          ))}
        </View>
      ))}
    </View>
  );
}
